module.exports = __webpack_public_path__ + "img/pagesix-4.b9f2d8e9.png";